export default "/assets/images/mila-filters.d8bc691a6f952903.png";